'use client';

import { AnimatePresence, motion } from 'framer-motion';
import { ReactNode } from 'react';

interface InspectTransitionProps {
  isOpen: boolean;
  children: ReactNode;
}

// Shared transition configuration for all inspect views
export const inspectTransitionConfig = {
  initial: { opacity: 0, scale: 0.95, y: 20 },
  animate: { opacity: 1, scale: 1, y: 0 },
  exit: { opacity: 0, scale: 0.95, y: 20 },
  transition: { duration: 0.3, ease: [0.16, 1, 0.3, 1] },
};

// Backdrop transition
export const backdropTransitionConfig = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.3 },
};

export default function InspectTransition({ isOpen, children }: InspectTransitionProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40"
            {...backdropTransitionConfig}
          />

          {/* Content */}
          <motion.div className="fixed inset-0 z-50 overflow-y-auto" {...inspectTransitionConfig}>
            {children}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}

// Hook for content animations inside inspect views
export function useInspectContentAnimation(delay: number = 0) {
  return {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.3, delay, ease: 'easeOut' },
  };
}
